import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EnrollmentType } from '../../components/enums/enrollment-type';
import ClaycoForm from '../../components/form_elements/clayco-form';
import BeneficiariesUpdate from './beneficiaries-update';
import LifeEvent from './life-event';
import OpenEnrollment from './open-enrollment';
import * as Yup from 'yup';
import { OptionalDate, OptionalString, RequiredDate, RequiredNumber, RequiredString } from "../../components/form_elements/form-validators";
import useMsalApi from '../../components/use-msal-api';
import { useNavigate } from 'react-router';
import { Row, Column, Link, Button } from 'carbon-components-react';
import {  updateEnrollments } from '../../redux/actions/enrollments-actions';

const ExistingEmployee = () => {
    const enrollments = useSelector(s => s.enrollments);
    const navigate = useNavigate();
    const [submitting, setSubmitting] = useState(false);
    const [callApi] = useMsalApi();
    const dispatch = useDispatch();
    const admin = useSelector(s => s.admin);

    const validationSchema = Yup.object().shape({
        enrollmentsType: RequiredNumber("Required"),
        effectiveDate: OptionalDate().when("enrollmentsType", {is: 2, then: RequiredDate("Required")}),
        lifeEventId: OptionalString().when("enrollmentsType", {is: 2, then: RequiredString("Required")}),
        lifeEventDescription: OptionalString().when("enrollmentsType", {is: 2, then: RequiredString("Required")})
    });



    const onSubmit = async(formData) => {
        const frm = validationSchema.cast(formData);
        console.log(frm);
        setSubmitting(true);

        const params = {
            enrollmentTypeId: frm.enrollmentsType,
            effectiveDate: frm.effectiveDate,
            lifeEventId: frm.lifeEventId,
            lifeEventDescription: frm.lifeEventDescription,
            currentStep: enrollments.currentStep 
        }


        const results = await callApi(`Enrollments/${enrollments.id}/effectiveDate/${enrollments.employee.id}`, "PATCH", params);
        if(!results.error){
            dispatch(updateEnrollments(results));
            if(params.enrollmentTypeId === EnrollmentType.BenficiaryChange)
                navigate("/Beneficiaries")
            else
                navigate("/Employee");
        }



        setSubmitting(false);
    }

    const onError = (errors) => {
        console.log(errors);
    }


    return ( 
        <ClaycoForm schema={validationSchema} onSubmit={onSubmit} onError={onError}>
        <div className="font-bold text-3xl mb-4">
            Employee Benefits for {enrollments?.employee?.firstName} {enrollments?.employee?.lastName}</div>
        <div className="text-lg mb-4"><Button  onClick={() => {navigate("/Elections")}} >View Current Elections</Button></div>
        <hr className='mb-6' />
        <Row>
            <Column sm={{span: 0}} md={{span: 8}}>
                <div className='grid grid-cols-2 gap-8'>
                    {enrollments.isOpenEnrollment ? 
                        <OpenEnrollment alreadyEnrolled={enrollments.alreadyEnrolled} submitting={submitting} />
                    :<></>
                    }
                    <LifeEvent submitting={submitting} lastColumn={enrollments.isOpenEnrollment} />
                    {!enrollments.isOpenEnrollment ? 
                         <BeneficiariesUpdate submitting={submitting} />
                    :<></>
                    }
                </div>
            </Column>
            <Column md={{span:0}}>
                    {enrollments.isOpenEnrollment ? 
                        <>
                            <OpenEnrollment alreadyEnrolled={enrollments.alreadyEnrolled} submitting={submitting} lastColumn={true} />
                            <hr className='mb-8' />
                        </>
                    :<></>
                    }
                    <LifeEvent submitting={submitting} lastColumn={true} />
                    {!enrollments.isOpenEnrollment ? 
                        <>
                            <hr className='mb-8' />
                            <BeneficiariesUpdate submitting={submitting} />
                        </>
                    :<></>
                    }
            </Column>
        </Row>
        <p className='my-4'>
        <strong>Questions?</strong>  Contact Beth Mellenthin  at 314-592-2206 or Sara Benignus at 314-614-5880 or e-mail <a href='mailto:benefits@claycorp.com'>benefits@claycorp.com</a> . 
        </p>
      </ClaycoForm>
     );
}
 
export default ExistingEmployee;